import { TApplicationState } from '../../types/redux';

export function getFromDevelopersPropsCount(state: TApplicationState) {
  const {
    newbuilding: { fromDevelopersPropsCount },
  } = state;

  return fromDevelopersPropsCount;
}
